import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import BackImagDesk from "Images/quiz/upsell/upProductGuaranteeDesk.png";
import BackImgMob from "Images/quiz/upsell/upProductGuaranteeMob.png";
import styles from "./style.module.css";
const Happiness = () => {
    const isMobile = useScreenWidth() < 769;
    const BackPic = isMobile ? BackImgMob : BackImagDesk;
    return (_jsxs("div", { className: styles.happiness_container, children: [_jsx("img", { className: styles.happiness_back, src: BackPic, alt: "products" }), _jsxs("div", { className: styles.happiness_content, children: [_jsx("h1", { className: styles.happiness_title, children: "Happiness Guarantee" }), _jsx("p", { className: styles.happiness_text, children: "Don't love your blend? We'll send you a new one. Always. We make your health and happiness our priority." })] })] }));
};
export default Happiness;
